module.exports = __webpack_public_path__ + "img/logo.ff7fda0b.png";